import { render } from "./ConfigValidation.vue?vue&type=template&id=2bebc7e4&scoped=true"
import script from "./ConfigValidation.vue?vue&type=script&lang=js"
export * from "./ConfigValidation.vue?vue&type=script&lang=js"

import "./ConfigValidation.vue?vue&type=style&index=0&id=2bebc7e4&scoped=true&lang=css"
import "./ConfigValidation.vue?vue&type=style&index=1&id=2bebc7e4&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bebc7e4"]])

export default __exports__